import React from 'react';
import PropTypes from 'prop-types';
import IssuePreviewDetailsTabTitleSection from './IssuePreviewDetailsTabTitleSection';
import IssuePreviewDetailsTabGeneralSection from './IssuePreviewDetailsTabGeneralSection';
import IssuePreviewDetailsTabLinkedToSection from './IssuePreviewDetailsTabLinkedToSection';
import IssuePreviewDetailsTabBottomSection from './IssuePreviewDetailsTabBottomSection';
import IssuePreviewDetailsTabLinkedEntitiesSection from './IssuePreviewDetailsTabLinkedEntitiesSection';
import IssuePreviewDetailsTabCustomAttributesSection from './IssuePreviewDetailsTabCustomAttributesSection';
import {issueAttributesType} from '../../constants/proptype-validation';
import {isFedrampRegion} from '../../utils/region-helpers';

const IssuePreviewDetailsTab = ({issue, container, contentElementRef}) => (
  <div className="IssuePreviewDetailsTab" data-testid="IssuePreviewDetailsTab">
    <IssuePreviewDetailsTabTitleSection issue={issue} />
    <IssuePreviewDetailsTabGeneralSection issue={issue} container={container} contentElementRef={contentElementRef} />
    <IssuePreviewDetailsTabLinkedToSection issue={issue} container={container} contentElementRef={contentElementRef} />
    <IssuePreviewDetailsTabBottomSection issue={issue} container={container} />
    {!isFedrampRegion() && <IssuePreviewDetailsTabLinkedEntitiesSection issue={issue} container={container} />}
    <IssuePreviewDetailsTabCustomAttributesSection issue={issue} />
  </div>
);

IssuePreviewDetailsTab.displayName = 'IssuePreviewDetailsTab';

IssuePreviewDetailsTab.propTypes = {
  issue: issueAttributesType,
  container: PropTypes.object.isRequired,
  contentElementRef: PropTypes.object
};

export default IssuePreviewDetailsTab;
